import api from '@/api'

export default {
  namespaced: true,
  state: {
    workshop: [],
    isLoading: false
  },
  mutations: {
    SET_WORKSHOP (state, info) {
      state.workshop = info
    },
    SET_IS_LOADING (state, bool) {
      state.isLoading = bool
    },
    RESET_WORKSHOP (state) {
      state.workshop = []
    }
  },
  actions: {
    GET_WORKSHOP ({ commit, state }) {
      commit('SET_IS_LOADING', true)

      api.cabinet.getWorkshop()
        .then(res => {
          if (res.status === 'success') {
            commit('SET_WORKSHOP', res.purchased_products)
          }
        })
        // .catch(err => {
        //   console.log(err)
        // })
        .finally(() => {
          commit('SET_IS_LOADING', false)
        })
    },
    RESET_WORKSHOP_ACTION ({ commit }) {
      commit('RESET_WORKSHOP')
    }
  }
}
